(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.header.querySelector('header-drawer > details[open]')) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.header.querySelector('header-drawer > details[open]')) return;
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.header.querySelector('header-drawer > details[open]')) return;
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.header.querySelector('header-drawer > details[open]')) return;
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-tl-catalog]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const update = value => {
      root.dataset.view = ['6','4','2','1'].includes(value) ? value : '4';
      root.querySelectorAll('[data-columns]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.columns === root.dataset.view)));
    };
    try { update(sessionStorage.getItem('teolino-catalog-density-v2')); } catch { update('4'); }
    root.querySelectorAll('[data-columns]').forEach(button => button.addEventListener('click', () => {
      update(button.dataset.columns);
      try { sessionStorage.setItem('teolino-catalog-density-v2', root.dataset.view); } catch {}
    }));

    const sort = root.querySelector('[data-catalog-sort]');
    document.addEventListener('click', event => { if (sort && !sort.contains(event.target)) sort.open = false; });
    sort?.addEventListener('keydown', event => { if (event.key === 'Escape') { sort.open = false; sort.querySelector('summary').focus(); } });
    sort?.querySelectorAll('[data-sort-value]').forEach(link => link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const url = new URL(location.href);
      url.searchParams.set('sort_by', link.dataset.sortValue);
      url.searchParams.delete('page');
      location.assign(url.href);
    }));
    const grid = root.querySelector('.tl-catalog__grid');
    const area = root.querySelector('[data-load-area]');
    const link = root.querySelector('[data-load-more]');
    if (!area || !grid) return;
    let busy = false, failed = false, observer;
    let next = link?.href || '';
    const cacheKey = `teolino-catalog-return-v2:${location.pathname}${location.search}`;
    let restoring = false;
    let restoreFrame;
    let restoreTimer;
    const stopRestore = () => {
      restoring = false;
      cancelAnimationFrame(restoreFrame);
      clearTimeout(restoreTimer);
    };
    const save = () => {
      if (restoring) return;
      const record = {
        html: grid.innerHTML, next, y: window.scrollY,
        view: root.dataset.view, savedAt: Date.now()
      };
      try { sessionStorage.setItem(cacheKey, JSON.stringify(record)); } catch {}
    };
    const restorePosition = y => {
      stopRestore();
      restoring = true;
      const until = performance.now() + 1200;
      const place = () => {
        if (!restoring) return;
        window.scrollTo({ top: y, behavior: 'instant' });
        if (performance.now() < until) restoreFrame = requestAnimationFrame(place);
        else stopRestore();
      };
      restoreFrame = requestAnimationFrame(place);
      restoreTimer = setTimeout(stopRestore, 1500);
    };
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(type => window.addEventListener(type, stopRestore, { passive: true }));
    const back = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    if (back) {
      try {
        const record = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
        if (record && Date.now() - record.savedAt < 1800000 && typeof record.html === 'string' && Number.isFinite(record.y)) {
          grid.innerHTML = record.html;
          next = record.next || '';
          update(record.view);
          restorePosition(record.y);
        }
      } catch {}
    }
    root.addEventListener('click', event => {
      const product = event.target.closest('.tl-catalog__card a');
      if (product && !event.defaultPrevented && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) save();
    }, { capture: true });
    window.addEventListener('pagehide', save);
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      try {
        const record = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
        if (record && Number.isFinite(record.y)) restorePosition(record.y);
      } catch {}
    });
    const seen = new Set([...grid.querySelectorAll('.tl-catalog__card a')].map(a => a.getAttribute('href')));
    const message = area.querySelector('[data-load-message]');
    const count = area.querySelector('[data-loaded-count]');
    const updateCount = () => { count.textContent = area.dataset.countFormat.replace('__shown__', String(grid.querySelectorAll('.tl-catalog__card').length)); };
    updateCount();
    if (link) { link.hidden = !next; if (next) link.href = next; }
    const loadMore = async manual => {
      if (restoring || busy || !next || !link || (!manual && failed)) return;
      busy = true;
      failed = false;
      link.setAttribute('aria-disabled', 'true');
      grid.setAttribute('aria-busy', 'true');
      message.hidden = false;
      message.textContent = area.dataset.loading;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const url = new URL(next, location.href);
        if (url.origin !== location.origin) throw new Error('Unexpected origin');
        url.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Unavailable page');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = html.querySelector('[data-tl-catalog]');
        if (!incoming || !root.isConnected) throw new Error('Missing catalog');
        const cards = [...incoming.querySelectorAll('.tl-catalog__card')].filter(card => !seen.has(card.querySelector('a').getAttribute('href')));
        if (!cards.length) throw new Error('No new products');
        const focused = document.activeElement === link;
        const fragment = document.createDocumentFragment();
        cards.forEach(card => { seen.add(card.querySelector('a').getAttribute('href')); fragment.append(card); });
        grid.append(fragment);
        const upcoming = incoming.querySelector('[data-load-more]');
        next = upcoming ? new URL(upcoming.getAttribute('href'), location.href).href : '';
        if (next) link.href = next;
        else { link.hidden = true; observer?.disconnect(); }
        updateCount();
        message.hidden = true;
        if (manual && focused) cards[0].querySelector('a').focus({ preventScroll: true });
      } catch {
        failed = true;
        message.textContent = area.dataset.error;
      } finally {
        clearTimeout(timeout);
        busy = false;
        link.removeAttribute('aria-disabled');
        grid.removeAttribute('aria-busy');
      }
      if (next && !failed) requestAnimationFrame(() => {
        if (area.getBoundingClientRect().top < innerHeight + 500) loadMore(false);
      });
    };
    link?.addEventListener('click', event => { event.preventDefault(); loadMore(true); });
    if (link && next && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (!root.isConnected) { observer.disconnect(); return; }
        if (entries[0].isIntersecting) loadMore(false);
      }, { rootMargin: '500px 0px' });
      observer.observe(area);
    }
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-header-before-icons"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-header-pre-color"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-backup-circle"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-aligned-title-20261021"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-backdrop-fix-20261020"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        this.inboxPerch = document.getElementById('tl-raccoon-inbox-perch');
        this.perchTimer = setInterval(() => this.updateInboxPerch(), 450);
        window.addEventListener('resize', () => this.updateInboxPerch(), { signal: this.controller.signal });
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      updateInboxPerch() {
        const perch=this.inboxPerch;
        if(!perch)return;
        const chat=this.chat;
        if(!chat?.isConnected||!chat.hasAttribute('open')){perch.hidden=true;return;}
        const shadow=chat.shadowRoot;
        let rect=null;
        if(shadow){
          const candidates=[...shadow.querySelectorAll('[part~="dialog"],dialog,[role="dialog"],.panel')];
          rect=candidates.map(el=>el.getBoundingClientRect())
            .filter(r=>r.width>Math.min(260,innerWidth*.6)&&r.height>180&&r.top>=0&&r.top<innerHeight*.85)
            .sort((a,b)=>b.height-a.height)[0]||null;
        }
        const center=rect?rect.left+rect.width/2:innerWidth/2;
        const y=rect?rect.top-82:Math.round(innerHeight*.31)-82;
        perch.style.setProperty('--tl-perch-x',Math.round(center)+'px');
        perch.style.setProperty('--tl-perch-y',Math.max(70,Math.round(y))+'px');
        perch.hidden=false;
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        this.updateInboxPerch();
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        clearInterval(this.perchTimer);
        if(this.inboxPerch)this.inboxPerch.hidden=true;
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-clip-correction-20261020"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        this.inboxPerch = document.getElementById('tl-raccoon-inbox-perch');
        this.perchTimer = setInterval(() => this.updateInboxPerch(), 450);
        window.addEventListener('resize', () => this.updateInboxPerch(), { signal: this.controller.signal });
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      updateInboxPerch() {
        // Raccoon is painted by ::part(dialog) pseudo-elements so it cannot
        // be clipped or lost by moving DOM into the Inbox shadow tree.
        if(this.inboxPerch)this.inboxPerch.hidden=true;
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        this.updateInboxPerch();
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        clearInterval(this.perchTimer);
        if(this.inboxPerch)this.inboxPerch.hidden=true;
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-compact-inbox-20261020"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-compact-refine-20261021"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-ears-fix-20261021"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-header-up-20261021"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-inline-header-20261021"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-left-title-20261021"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-login-compact-test-20261021"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-mascot-position-20261020"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        this.inboxPerch = document.getElementById('tl-raccoon-inbox-perch');
        this.perchTimer = setInterval(() => this.updateInboxPerch(), 450);
        window.addEventListener('resize', () => this.updateInboxPerch(), { signal: this.controller.signal });
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      updateInboxPerch() {
        // Raccoon is painted by ::part(dialog) pseudo-elements so it cannot
        // be clipped or lost by moving DOM into the Inbox shadow tree.
        if(this.inboxPerch)this.inboxPerch.hidden=true;
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        this.updateInboxPerch();
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        clearInterval(this.perchTimer);
        if(this.inboxPerch)this.inboxPerch.hidden=true;
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-one-piece-header-20261021"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-opaque-layer-20261020"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        this.inboxPerch = document.getElementById('tl-raccoon-inbox-perch');
        this.perchTimer = setInterval(() => this.updateInboxPerch(), 450);
        window.addEventListener('resize', () => this.updateInboxPerch(), { signal: this.controller.signal });
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      updateInboxPerch() {
        const perch=this.inboxPerch;
        const chat=this.chat;
        if(!perch)return;
        if(!chat?.isConnected||!chat.hasAttribute('open')){perch.hidden=true;return;}
        const shadow=chat.shadowRoot;
        const dialog=shadow?.querySelector('dialog[open], [part~="dialog"], dialog, [role="dialog"]');
        if(!dialog){perch.hidden=true;return;}
        // The Inbox dialog is in the browser top layer. A mascot placed outside
        // that dialog gets covered by it; keep the mascot INSIDE the dialog.
        if(perch.parentNode!==dialog)dialog.appendChild(perch);
        if(shadow&&!shadow.querySelector('#tl-perch-inside-inbox-styles')){
          const sheet=document.createElement('style');
          sheet.id='tl-perch-inside-inbox-styles';
          sheet.textContent='.tl-raccoon-inbox-perch[hidden]{display:none!important}.tl-raccoon-inbox-perch{position:absolute!important;top:55px!important;left:50%!important;transform:translateX(-50%)!important;z-index:100!important;width:116px!important;height:96px!important;pointer-events:none!important}.tl-raccoon-inbox-head{position:absolute;top:0;left:10px;width:96px;height:auto}.tl-raccoon-inbox-paw{position:absolute;bottom:-2px;width:29px;height:25px;object-fit:contain}.tl-raccoon-inbox-left{left:9px}.tl-raccoon-inbox-right{right:9px}@media(max-width:600px){.tl-raccoon-inbox-perch{top:54px!important;width:106px!important;height:90px!important}.tl-raccoon-inbox-head{left:9px;width:88px}.tl-raccoon-inbox-paw{width:27px;height:23px}}';
          shadow.appendChild(sheet);
        }
        perch.hidden=false;
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        this.updateInboxPerch();
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        clearInterval(this.perchTimer);
        if(this.inboxPerch)this.inboxPerch.hidden=true;
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-original-restore-20261020"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        this.inboxPerch = document.getElementById('tl-raccoon-inbox-perch');
        this.perchTimer = setInterval(() => this.updateInboxPerch(), 450);
        window.addEventListener('resize', () => this.updateInboxPerch(), { signal: this.controller.signal });
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      updateInboxPerch() {
        // Raccoon is painted by ::part(dialog) pseudo-elements so it cannot
        // be clipped or lost by moving DOM into the Inbox shadow tree.
        if(this.inboxPerch)this.inboxPerch.hidden=true;
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        this.updateInboxPerch();
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        clearInterval(this.perchTimer);
        if(this.inboxPerch)this.inboxPerch.hidden=true;
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-perched-20261020"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-responsive-header-20261021"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-small-body-20261020"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        this.inboxPerch = document.getElementById('tl-raccoon-inbox-perch');
        this.perchTimer = setInterval(() => this.updateInboxPerch(), 450);
        window.addEventListener('resize', () => this.updateInboxPerch(), { signal: this.controller.signal });
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      updateInboxPerch() {
        // Raccoon is painted by ::part(dialog) pseudo-elements so it cannot
        // be clipped or lost by moving DOM into the Inbox shadow tree.
        if(this.inboxPerch)this.inboxPerch.hidden=true;
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        this.updateInboxPerch();
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        clearInterval(this.perchTimer);
        if(this.inboxPerch)this.inboxPerch.hidden=true;
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-smaller-head-20261021"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-solid-header-20261021"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat-before-supported-cleanup-20261021"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.notice.hidden = true;
        this.syncState();
      }
      syncState() {
        const open = this.chat.hasAttribute('open');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-raccoon-chat"]) return;
  try {
    
  if (!customElements.get('tl-raccoon-chat')) {
    customElements.define('tl-raccoon-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.failedChats = new WeakSet();
        this.button = this.querySelector('.tl-raccoon-chat__button');
        this.hideButton = this.querySelector('.tl-raccoon-chat__hide');
        this.notice = this.querySelector('[role="status"]');
        let savedState = 'peek';
        try { savedState = localStorage.getItem('tl-raccoon-state-v3') || 'peek'; } catch {}
        this.entrancePending = savedState === 'expanded';
        this.setState(savedState, false);
        document.addEventListener('keydown', event => {
          if (event.key === 'Tab') { this.keyboardMode = true; this.button.setAttribute('data-keyboard-focus', ''); }
        }, { signal: this.controller.signal });
        this.button.addEventListener('click', event => {
          if (this.suppressClick) {
            this.suppressClick = false;
            event.preventDefault();
            return;
          }
          if (this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting')) this.setPeeking(false);
          else this.openChat();
        }, { signal: this.controller.signal });
        this.hideButton.addEventListener('click', () => this.tuckFurther(), { signal: this.controller.signal });
        this.button.addEventListener('keydown', event => {
          this.keyboardMode = true;
          this.button.setAttribute('data-keyboard-focus', '');
          if (event.key === 'ArrowRight' || event.key === 'Escape') {
            event.preventDefault();
            this.tuckFurther();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setState('expanded');
          }
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.suppressClick = false;
          this.keyboardMode = false;
          this.button.removeAttribute('data-keyboard-focus');
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.button.setPointerCapture?.(event.pointerId);
        }, { signal: this.controller.signal });
        this.button.addEventListener('pointermove', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture.lastX = event.clientX;
          this.gesture.lastY = event.clientY;
          const dx = event.clientX - this.gesture.x;
          const dy = Math.abs(event.clientY - this.gesture.y);
          this.gesture.horizontal = Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25;
          if (this.gesture.horizontal && event.cancelable) event.preventDefault();
        }, { signal: this.controller.signal, passive: false });
        const finishGesture = event => {
          const start = this.gesture;
          this.gesture = null;
          if (!start || event.pointerId !== start.id) return;
          if (event.type === 'pointercancel' && !start.horizontal) return;
          const endX = event.type === 'pointercancel' ? start.lastX : event.clientX;
          const endY = event.type === 'pointercancel' ? start.lastY : event.clientY;
          const dx = endX - start.x;
          const dy = Math.abs(endY - start.y);
          if (Math.abs(dx) > 18 && Math.abs(dx) > dy * 1.25) {
            this.suppressClick = true;
            if (dx > 0) this.tuckFurther();
            else this.setState('expanded');
          }
        };
        this.button.addEventListener('pointerup', finishGesture, { signal: this.controller.signal });
        this.button.addEventListener('pointercancel', finishGesture, { signal: this.controller.signal });
        this.querySelector('.tl-raccoon-chat__sprite').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__walker').style.setProperty('--tl-raccoon-sprite', `url("${this.dataset.spriteUrl}")`);
        this.querySelector('.tl-raccoon-chat__grip').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.querySelector('.tl-raccoon-chat__paw').style.setProperty('--tl-raccoon-grip', `url("${this.dataset.gripUrl}")`);
        this.sprite = this.querySelector('.tl-raccoon-chat__sprite');
        this.poseStartedAt = Date.now();
        this.poseImage = new Image();
        this.poseImage.onload = () => {
          if (!this.isConnected) return;
          this.toggleAttribute('data-pose-ready', true);
          this.sprite.style.setProperty('--tl-raccoon-poses', `url("${this.dataset.posesUrl}")`);
          this.updatePose();
          this.maybeStartEntrance();
        };
        this.poseImage.src = this.dataset.posesUrl;
        this.walkImage = new Image();
        this.walkImage.onload = this.walkImage.onerror = () => {
          if (!this.isConnected) return;
          this.walkReady = true;
          this.maybeStartEntrance();
        };
        this.walkImage.src = this.dataset.spriteUrl;
        this.gripImage = new Image();
        this.gripImage.onload = () => {
          if (this.isConnected) this.toggleAttribute('data-grip-ready', true);
        };
        this.gripImage.src = this.dataset.gripUrl;
        this.poseTimer = setInterval(() => this.updatePose(), 80);
        document.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || !this.chat?.open) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const close = path.find(element => element instanceof Element && element.matches('.panel__close'));
          if (!close) return;
          event.preventDefault();
          if (window.matchMedia('(min-width: 990px)').matches) {
            event.stopImmediatePropagation();
            this.closeChat();
            return;
          }
          close.click();
          this.closeChat();
        }, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('click', event => {
          if (!this.chat?.open) return;
          const path = event.composedPath();
          if (path.includes(this.chat) && path.some(element => element instanceof Element && element.matches('.panel__close'))) {
            if (window.matchMedia('(min-width: 990px)').matches) {
              event.preventDefault();
              event.stopImmediatePropagation();
              this.closeChat();
              return;
            }
            queueMicrotask(() => this.closeChat());
          }
        }, { capture: true, signal: this.controller.signal });
        // iOS Chrome / Shopify Inbox composer focus retention experiment.
        // Observe the active composer rather than relying on a translated Send label.
        this.recordComposer = event => {
          if (!this.chat?.hasAttribute('open')) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const field = path.find(node => node instanceof HTMLElement &&
            node.matches('textarea, input:not([type="hidden"]):not([type="checkbox"]), [contenteditable="true"], [role="textbox"]'));
          if (field && !field.matches('input[type="search"]')) this.activeComposer = field;
        };
        document.addEventListener('focusin', this.recordComposer, { capture: true, signal: this.controller.signal });
        this.focusGuard = event => {
          if (!this.chat?.hasAttribute('open') || !this.activeComposer?.isConnected) return;
          const path = event.composedPath();
          if (!path.includes(this.chat)) return;
          const field = this.activeComposer;
          const button = path.find(node => node instanceof HTMLElement &&
            (node.matches('button, [role="button"], input[type="submit"]')));
          if (!button) return;
          const form = field.closest('form');
          const buttonForm = button.closest('form');
          const label = [button.getAttribute('aria-label'), button.getAttribute('title'), button.getAttribute('data-testid')].filter(Boolean).join(' ');
          const isSend = (form && buttonForm === form &&
            !button.matches('[type="reset"]')) ||
            /send|odeslat|poslat|submit|message/i.test(label);
          if (!isSend) return;
          // Blocking button focus before the click is more reliable on iOS than
          // re-opening the keyboard after Safari/WebKit has dismissed it.
          if (event.cancelable) event.preventDefault();
          if (document.activeElement !== field) field.focus({ preventScroll: true });
        };
        document.addEventListener('pointerdown', this.recordComposer, { capture: true, signal: this.controller.signal });
        document.addEventListener('pointerdown', this.focusGuard, { capture: true, passive: false, signal: this.controller.signal });
        document.addEventListener('submit', event => {
          if (!this.chat?.hasAttribute('open') || !this.activeComposer?.isConnected) return;
          if (!event.composedPath().includes(this.chat)) return;
          const field = this.activeComposer;
          queueMicrotask(() => {
            if (field.isConnected && this.chat?.hasAttribute('open')) field.focus({ preventScroll: true });
          });
        }, { capture: true, signal: this.controller.signal });
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && window.matchMedia('(min-width: 990px)').matches && this.chat?.hasAttribute('open') && !this.desktopRuntime()?.hasAttribute('data-tl-minimized')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.closeChat();
          }
        }, { capture: true, signal: this.controller.signal });
        this.findChat();
        this.watchDocument = new MutationObserver(() => this.findChat());
        this.watchDocument.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => {
          if (this.isConnected) this.findChat();
        });
        if (this.hasAttribute('data-editor-preview') && !this.chat) {
          this.button.hidden = false;
          this.hideButton.hidden = false;
        }
      }
      setPeeking(value) {
        this.setState(value ? 'peek' : 'expanded');
      }
      poseAt(elapsed, bowing) {
        if (bowing) {
          if (elapsed < 200 || elapsed >= 1400) return 0;
          if (elapsed < 400) return 1;
          if (elapsed < 850) return 2;
          if (elapsed < 1100) return 3;
          return 1;
        }
        const t = elapsed % 12000;
        if (t < 2000) return 0;
        if (t < 4000) return 4;
        if (t < 4500) return 0;
        if (t < 6500) return 5;
        if (t < 9000) return 6;
        if (t >= 9500 && t < 9660) return 7;
        return 0;
      }
      updatePose() {
        if (!this.hasAttribute('data-pose-ready') || this.hasAttribute('data-peeking') || document.hidden) return;
        const frame = this.poseAt(Date.now() - this.poseStartedAt, this.hasAttribute('data-bowing'));
        if (frame === this.lastPose) return;
        const offsets = [[12.12,-3],[11.88,-3],[13.25,-3],[17.25,-3],[16.62,5.75],[7.88,5.25],[14.12,5],[17.75,5.5]];
        this.sprite.style.backgroundPosition = `${-(frame % 4) * 96}px ${-Math.floor(frame / 4) * 128}px`;
        this.sprite.style.left = `${offsets[frame][0]}px`;
        this.sprite.style.top = `${offsets[frame][1]}px`;
        this.lastPose = frame;
      }
      tuckFurther() {
        this.setState(this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? 'tucked' : 'peek');
      }
      maybeStartEntrance() {
        if (!this.entrancePending || !this.walkReady || !this.hasAttribute('data-pose-ready') || this.button.hidden) return;
        this.entrancePending = false;
        if (!this.hasAttribute('data-peeking')) this.setState('expanded', false, true);
      }
      setState(value, persist = true, animateEntrance = false) {
        const state = ['expanded', 'peek', 'tucked'].includes(value) ? value : 'peek';
        if (persist) this.entrancePending = false;
        if (persist && state !== 'expanded' && !this.hasAttribute('data-peeking')) {
          this.pendingState = state;
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.hasAttribute('data-exiting')) return;
          clearTimeout(this.enterTimer);
          clearTimeout(this.bowTimer);
          this.removeAttribute('data-entering');
          this.removeAttribute('data-bowing');
          this.toggleAttribute('data-exiting', true);
          this.notice.hidden = true;
          this.updateLabel();
          this.exitTimer = setTimeout(() => this.setState(this.pendingState, false), 900);
          return;
        }
        clearTimeout(this.exitTimer);
        this.removeAttribute('data-exiting');
        this.pendingState = null;
        const entering = state === 'expanded' && (animateEntrance || (persist && this.hasAttribute('data-peeking')));
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        this.toggleAttribute('data-bowing', false);
        this.toggleAttribute('data-entering', entering);
        if (entering) this.enterTimer = setTimeout(() => {
          this.removeAttribute('data-entering');
          this.toggleAttribute('data-bowing', true);
          this.poseStartedAt = Date.now();
          this.updatePose();
          this.bowTimer = setTimeout(() => {
            this.removeAttribute('data-bowing');
            this.poseStartedAt = Date.now();
            this.updatePose();
          }, 1600);
        }, 900);
        this.toggleAttribute('data-peeking', state !== 'expanded');
        this.toggleAttribute('data-tucked', state === 'tucked');
        if (state === 'expanded' && !entering) this.poseStartedAt = Date.now();
        this.notice.hidden = true;
        this.updateLabel();
        if (persist) {
          try { localStorage.setItem('tl-raccoon-state-v3', state); } catch {}
          if (this.keyboardMode) this.button.focus({ preventScroll: true });
        }
      }
      updateLabel() {
        this.button.setAttribute('aria-label', this.hasAttribute('data-peeking') || this.hasAttribute('data-exiting') ? this.dataset.restoreLabel : this.dataset.openLabel);
      }
      findChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function' || this.failedChats.has(chat)) return;
        if (this.chat === chat) return;
        this.releaseChat();
        this.chat = chat;
        chat.classList.add('tl-raccoon-chat-native');
        this.watchChat = new MutationObserver(() => this.syncState());
        this.watchChat.observe(chat, { attributes: true, attributeFilter: ['open'] });
        this.brandRoot = chat.shadowRoot || null;
        if (this.brandRoot) {
          this.brandObserver = new MutationObserver(() => this.installBranding());
          this.brandObserver.observe(this.brandRoot, { childList: true, subtree: true });
        }
        this.notice.hidden = true;
        this.syncState();
      }
      desktopRuntime() {
        return this.chat?.shadowRoot?.querySelector('shopify-agent-runtime');
      }
      installDesktopStyle(root) {
        if (!root.querySelector('.panel') || root.querySelector('[data-tl-desktop-style]')) return;
        const style = document.createElement('style');
        style.setAttribute('data-tl-desktop-style', '');
        style.textContent = `@media(min-width:990px){
          :host{pointer-events:none!important}
          .backdrop{display:none!important;pointer-events:none!important}.panel__close{display:none!important}.tl-desktop-close{display:block!important;position:absolute;right:12px;top:12px;width:40px;height:40px;z-index:20;border:0;background:#faf8f0;color:#493228;font-size:28px;cursor:pointer}
          .panel{display:flex!important;visibility:visible;position:fixed!important;inset:auto 24px 24px auto!important;width:400px!important;max-width:calc(100vw - 48px)!important;height:620px!important;max-height:calc(100dvh - 64px)!important;pointer-events:auto!important;opacity:1;transform:translateX(0);transition:transform .4s ease,opacity .4s ease!important}
          :host([data-tl-minimized]) .panel{transform:translateX(calc(100% + 40px));opacity:0;pointer-events:none!important;visibility:hidden;transition:transform .4s ease,opacity .4s ease,visibility 0s .4s!important}
          @starting-style{.panel{opacity:0;transform:translateX(calc(100% + 40px))}}
        } @media(max-width:989px){.tl-desktop-close{display:none!important}} @media(prefers-reduced-motion:reduce){.panel{transition:none!important}}`;
        root.appendChild(style);
        const panel = root.querySelector('.panel');
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'tl-desktop-close';
        close.textContent = '×';
        close.setAttribute('aria-label', root.querySelector('.panel__close')?.getAttribute('label') || 'Close');
        close.addEventListener('click', event => { event.preventDefault(); event.stopImmediatePropagation(); this.closeChat(); }, {signal:this.controller.signal});
        panel.appendChild(close);
        for (const type of ['pointerdown', 'pointerup', 'click']) {
          root.addEventListener(type, event => {
            if (!window.matchMedia('(min-width: 990px)').matches) return;
            if (!event.composedPath().some(node => node instanceof Element && node.matches('.panel__close'))) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            if (type === 'click') this.closeChat();
          }, { capture: true, passive: false, signal: this.controller.signal });
        }
      }
      installBranding() {
        if (!this.chat?.hasAttribute('open')) return;
        const roots = [this.chat.shadowRoot].filter(Boolean);
        const seen = new Set();
        while (roots.length) {
          const root = roots.shift();
          if (!root || seen.has(root)) continue;
          seen.add(root);
          // The native dialog is an exposed part in versions of Shopify Inbox
          // that support the existing header CSS. Injecting an actual element
          // avoids dependence on ::part(dialog)::after pseudo-element rendering.
          this.installDesktopStyle(root);
          const dialog = root.querySelector('[part~="dialog"]');
          if (dialog && !dialog.querySelector('[data-tl-raccoon-brand]')) {
            const brand = document.createElement('div');
            brand.setAttribute('data-tl-raccoon-brand', '');
            brand.textContent = 'Mýval Teolino';
            brand.style.cssText = 'position:absolute;top:8px;left:110px;right:53px;height:48px;padding:0 0 0 48px;box-sizing:border-box;z-index:8;pointer-events:none;background:#faf8f0 url("https://cdn.shopify.com/s/files/1/0911/3082/3034/files/teolino-raccoon-opaque-face-v22.png?v=1792337604") left center / 40px auto no-repeat;color:#493228;font:700 14px/48px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;';
            dialog.appendChild(brand);
            this.chat.classList.add('tl-raccoon-chat-overlay-ready');
            return;
          }
          for (const node of root.querySelectorAll('*')) {
            if (node.shadowRoot) roots.push(node.shadowRoot);
          }
        }
      }
      syncState() {
        if (window.matchMedia('(min-width: 990px)').matches && this.chat.hasAttribute('open')) this.desktopActive = true;
        const open = (this.chat.hasAttribute('open') || (window.matchMedia('(min-width: 990px)').matches && this.desktopActive)) && !this.desktopRuntime()?.hasAttribute('data-tl-minimized');
        this.button.hidden = open;
        this.hideButton.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (!open) this.maybeStartEntrance();
        else this.installBranding();
        if (this.wasOpen && !open && this.keyboardMode) this.button.focus({ preventScroll: true });
        this.wasOpen = open;
      }
      closeChat() {
        if (window.matchMedia('(min-width: 990px)').matches && (this.desktopActive || this.chat?.hasAttribute('open'))) {
          const runtime = this.desktopRuntime();
          if (runtime) {
            runtime.setAttribute('data-tl-minimized', '');
            const panel = runtime.shadowRoot?.querySelector('.panel');
            panel?.setAttribute('inert', '');
            panel?.setAttribute('aria-hidden', 'true');
            this.setState('expanded', false, true);
            this.syncState();
            return;
          }
        }
        if (!this.chat || typeof this.chat.close !== 'function') return;
        clearTimeout(this.openTimer);
        this.button.disabled = false;
        this.chat.close();
        this.syncState();
      }
      openChat() {
        const runtime = this.desktopRuntime();
        if (runtime?.hasAttribute('data-tl-minimized')) {
          runtime.removeAttribute('data-tl-minimized');
          const panel = runtime.shadowRoot?.querySelector('.panel');
          panel?.removeAttribute('inert');
          panel?.removeAttribute('aria-hidden');
          
          this.syncState();
          return;
        }
        if (!this.chat?.isConnected) {
          this.releaseChat();
          this.findChat();
        }
        if (!this.chat) {
          if (this.hasAttribute('data-editor-preview')) this.notice.hidden = !this.notice.hidden;
          return;
        }
        try {
          this.button.disabled = true;
          this.chat.show();
          this.openTimer = setTimeout(() => {
            this.button.disabled = false;
            if (!this.isConnected || !this.chat) return;
            if (!this.chat.hasAttribute('open')) {
              this.failedChats.add(this.chat);
              this.releaseChat();
              this.button.hidden = true;
              this.hideButton.hidden = true;
            } else {
              this.syncState();
            }
          }, 1200);
        } catch {
          this.button.disabled = false;
          this.failedChats.add(this.chat);
          this.releaseChat();
          this.button.hidden = true;
          this.hideButton.hidden = true;
        }
      }
      releaseChat() {
        this.brandObserver?.disconnect();
        this.brandObserver = null;
        this.brandRoot = null;
        this.activeComposer = null;
        this.chat?.classList.remove('tl-raccoon-chat-overlay-ready');
        this.watchChat?.disconnect();
        clearTimeout(this.openTimer);
        this.chat?.classList.remove('tl-raccoon-chat-native');
        this.chat = null;
        this.wasOpen = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.enterTimer);
        clearTimeout(this.bowTimer);
        clearTimeout(this.exitTimer);
        clearTimeout(this.openTimer);
        clearInterval(this.poseTimer);
        if (this.poseImage) this.poseImage.onload = null;
        if (this.walkImage) this.walkImage.onload = this.walkImage.onerror = null;
        if (this.gripImage) this.gripImage.onload = null;
        this.controller = null;
        this.watchDocument?.disconnect();
        this.releaseChat();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
